import _asyncToGenerator from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _classCallCheck from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _slice from "lodash/slice";
import _findIndex from "lodash/findIndex";
import _random from "lodash/random";
import _intersection from "lodash/intersection";
import _isEqual from "lodash/isEqual";
import _isEmpty from "lodash/isEmpty";
import _indexOf from "lodash/indexOf";
import _difference from "lodash/difference";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.values.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue"; // @ts-ignore
// import _ from "lodash";

import MatImage from "./MatImage.vue";
import CloseIcon from 'vue-material-design-icons/Close.vue';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import { Watch } from "vue-property-decorator";

var KitDialog = /*#__PURE__*/function (_Vue) {
  _inherits(KitDialog, _Vue);

  var _super = _createSuper(KitDialog);

  function KitDialog() {
    var _this;

    _classCallCheck(this, KitDialog);

    _this = _super.apply(this, arguments);
    _this.defaultShape = "PRO0000480"; // OV-580F

    _this.defaultSample = "PLA0001421"; // tavoletta per campione colore

    _this.useModel = true;
    _this.showKitDialog = false;
    _this.findColor = "";
    _this.itemsAmount = 30;
    _this.settingRandomColors = false; // finitura: String = "";

    _this.optionFiltroColori = [];
    _this.filtroColori = "";
    _this.category = [];
    _this.categories = [];
    _this.noImageColor = [];
    _this.selectedColors = new Array(30);
    _this.lineKits = [];
    _this.activeItem = 0;
    _this.selectedKit = "";
    _this.filtriColori = [{
      nome: "rosa",
      max: 345,
      min: 300,
      style: {
        background: "#ff00ff"
      }
    }, {
      nome: "viola",
      max: 299,
      min: 239,
      style: {
        background: "#8000ff"
      }
    }, {
      nome: "blue",
      max: 238,
      min: 190,
      style: {
        background: "#0000ff"
      }
    }, {
      nome: "verde",
      max: 189,
      min: 75,
      style: {
        background: "#00ff00"
      }
    }, {
      nome: "giallo",
      max: 74,
      min: 48,
      //background:'#ffff00',
      style: {
        background: "#ffff00"
      }
    }, {
      nome: "arancione",
      max: 47,
      min: 14,
      style: {
        background: "#ff8000"
      }
    }, {
      nome: "rosso",
      max: 13,
      min: 0,
      style: {
        background: "#ff0000"
      }
    }, {
      nome: "bianco/nero",
      max: -1,
      min: -2,
      style: {
        background: "linear-gradient(to bottom right, #FFFFFF 50%, #000000 50%)"
      }
    }];
    return _this;
  }

  _createClass(KitDialog, [{
    key: "colori",
    get: function get() {
      return this.$store.state.configurator.frontali.colors;
    }
  }, {
    key: "filteredColors",
    get: function get() {
      var q = this.findColor;
      var c = this.category;
      var f = this.filtroColori;
      var result = this.colori;

      if (q) {
        result = result.filter(function (color) {
          return color.PLASTICA.indexOf(q) > -1;
        });
      }

      if (c.length > 0) {
        if (result) {
          result = result.filter(function (color) {
            return c.indexOf(color.Category) >= 0;
          });
        }
      }

      if (f != "") {
        result = result.filter(function (color) {
          return color.Order <= f.max && color.Order >= f.min;
        });
      }

      return _difference(result, this.noImageColor);
    }
  }, {
    key: "kitsNames",
    get: function get() {
      var kn = [];

      for (var i = 0; i < this.lineKits.length; i++) {
        if (_indexOf(kn, this.lineKits[i].name) < 0) {
          kn.push(this.lineKits[i].name);
        }
      }

      return kn;
    }
  }, {
    key: "totalSelectedColors",
    get: function get() {
      var t = 0;

      for (var i = 0; i < this.selectedColors.length; i++) {
        if (this.selectedColors[i] && this.selectedColors[i].color) {
          t++;
        }
      }

      return t;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      // @ts-ignore
      this.$rest.getColorsCategories().then(function (response) {
        var d = response.data;
        _this2.categories = Object.values(d);
      }); // @ts-ignore

      this.$rest.getLineKits().then(function (c) {
        return _this2.lineKits = c.data;
      });
    }
  }, {
    key: "isKitActive",
    value: function isKitActive(n) {
      var k = [];
      var sc = [];

      for (var i = 0; i < this.lineKits.length; i++) {
        if (!_isEmpty(this.lineKits[i]) && this.lineKits[i].name == n) k.push(this.lineKits[i].color);
      }

      for (var _i = 0; _i < this.selectedColors.length; _i++) {
        var _this$selectedColors$;

        if (!_isEmpty(this.selectedColors[_i])) sc.push((_this$selectedColors$ = this.selectedColors[_i].color) === null || _this$selectedColors$ === void 0 ? void 0 : _this$selectedColors$.U_THE_COLORE);
      }

      return _isEqual(k, _intersection(k, sc));
    }
  }, {
    key: "setCellColor",
    value: function setCellColor(color) {
      var _this3 = this;

      var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var test = this.selectedColors.filter(function (sc, i) {
        return !_isEmpty(sc) && sc.color == color && i != _this3.activeItem;
      });

      if (test.length == 0) {
        var cellContent = {
          color: color
        };

        if (model != "") {
          cellContent.modello = model;
        } else if (this.selectedColors[this.activeItem] && this.selectedColors[this.activeItem].modello) {
          cellContent.modello = this.selectedColors[this.activeItem].modello;
        }

        this.$set(this.selectedColors, this.activeItem, cellContent);

        if (this.activeItem < this.selectedColors.length - 1) {
          this.activeItem++;
        }
      } else if (!this.settingRandomColors) {
        _Message({
          message: "Il colore " + color.U_THE_COLORE + " è già presente nella lista!",
          type: 'warning'
        });
      }
    }
  }, {
    key: "emptyCell",
    value: function emptyCell(i) {
      this.$set(this.selectedColors, i, []);
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(v) {
      return _isEmpty(v);
    }
  }, {
    key: "setRandomKit",
    value: function setRandomKit() {
      this.settingRandomColors = true;
      var rndArray = [];
      var i = 0;
      this.activeItem = i;

      while (i < this.itemsAmount) {
        var rnd = _random(0, this.colori.length - 1);

        if (rndArray.indexOf(rnd) == -1) {
          this.setCellColor(this.colori[rnd]);
          rndArray.push(rnd);
          i++;
          this.activeItem = i;
        }
      }

      this.settingRandomColors = false;
    }
  }, {
    key: "addToCart",
    value: function () {
      var _addToCart = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch("configurator/cart/addFrontaliniToCart", this.selectedColors);

              case 2:
                if (this.$store.state.configurator.cart.addToCartSuccess) {
                  this.showKitDialog = false;

                  _Message({
                    message: "Carrello aggiornato con successo",
                    type: 'success'
                  });
                } else {
                  _Message({
                    message: "Errore nell'aggiornamento del carrello. Elementi non inseriti!",
                    type: 'error'
                  });
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function addToCart() {
        return _addToCart.apply(this, arguments);
      }

      return addToCart;
    }()
  }, {
    key: "selectedKitChanged",
    value: function selectedKitChanged(newVal) {
      var _this4 = this;

      if (newVal != "") {
        (function () {
          var kit = _this4.lineKits.filter(function (k) {
            return k.name == _this4.selectedKit;
          });

          if (_this4.itemsAmount == 30) {
            _this4.activeItem = 0;
            _this4.itemsAmount = 30;

            var _loop = function _loop(i) {
              var colorIndex = _findIndex(_this4.colori, function (c) {
                return c.U_THE_COLORE == kit[i].color;
              });

              _this4.setCellColor(_this4.colori[colorIndex], kit[i].Modello);
            };

            for (var i = 0; i < kit.length; i++) {
              _loop(i);
            }
          } else if (_this4.itemsAmount == 60) {
            _this4.activeItem = 0;
            _this4.itemsAmount = 60;

            var _loop2 = function _loop2(_i2) {
              var colorIndex = _findIndex(_this4.colori, function (c) {
                return c.U_THE_COLORE == kit[_i2].color;
              });

              _this4.setCellColor(_this4.colori[colorIndex], kit[_i2].Modello);
            };

            for (var _i2 = 0; _i2 < kit.length; _i2++) {
              _loop2(_i2);
            }
          } else if (_this4.itemsAmount == 100) {
            _this4.activeItem = 0;
            _this4.itemsAmount = 100;

            var _loop3 = function _loop3(_i3) {
              var colorIndex = _findIndex(_this4.colori, function (c) {
                return c.U_THE_COLORE == kit[_i3].color;
              });

              if (colorIndex != -1) {
                _this4.setCellColor(_this4.colori[colorIndex], kit[_i3].Modello);
              }
            };

            for (var _i3 = 0; _i3 < kit.length; _i3++) {
              _loop3(_i3);
            }
          }
        })();
      }
    }
  }, {
    key: "itemsAmountChanged",
    value: function itemsAmountChanged(newVal, oldVal) {
      if (oldVal < newVal) {
        var c = newVal - oldVal;

        for (var i = 0; i < c; i++) {
          this.selectedColors.push([]);
        }
      } else {
        // let last = this.selectedColors.length - (oldVal - newVal);
        this.selectedColors = _slice(this.selectedColors, 0, (oldVal - newVal) * -1);
      }

      if (this.activeItem != 0) this.activeItem = this.totalSelectedColors;
    }
  }]);

  return KitDialog;
}(Vue);

__decorate([Watch("selectedKit")], KitDialog.prototype, "selectedKitChanged", null);

__decorate([Watch("itemsAmount")], KitDialog.prototype, "itemsAmountChanged", null);

KitDialog = __decorate([Component({
  components: {
    MatImage: MatImage,
    CloseIcon: CloseIcon,
    PlusIcon: PlusIcon
  }
})], KitDialog);
export default KitDialog;